import { chipColours } from '@/themes/colours';
import { CaseStatuses, TaskDashboardStage } from '@/types/TaskDashboard/TaskDashboard.types';
import { curationAndCaseStages, taskDashboardStages } from './stages';
import { pseudoStatuses, pseudoStatusesMap } from '../Common/status';

export const caseStatuses = [
  'Sequencing',
  'Upcoming',
  'In Pipeline',
  'Ready to Start',
  'In Progress',
  'Done',
  'Withdrawn',
  'Failed',
  'Finalised',
  'Ready to Send',
  'Sent',
  'Sending',
  ...pseudoStatuses,
] as const;

export const caseStatusesMap: CaseStatuses = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Sequencing: {
    status: 'Sequencing',
    chipProps: {
      status: 'Sequencing',
      color: chipColours.chipGreyText,
      backgroundColor: chipColours.chipGreyBg,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Upcoming: {
    status: 'Upcoming',
    chipProps: {
      status: 'Upcoming',
      color: chipColours.chipGreyText,
      backgroundColor: chipColours.chipGreyBg,
    },
  },
  'In Pipeline': {
    status: 'In Pipeline',
    chipProps: {
      status: 'In Pipeline',
      color: chipColours.chipGreyText,
      backgroundColor: chipColours.chipGreyBg,
    },
  },
  'Ready to Start': {
    status: 'Ready to Start',
    chipProps: {
      status: 'Ready',
      color: chipColours.chipGreenText,
      backgroundColor: chipColours.chipGreenBg,
    },
  },
  'In Progress': {
    status: 'In Progress',
    chipProps: {
      status: 'In Progress',
      color: chipColours.chipBlueText,
      backgroundColor: chipColours.chipBlueBg,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Done: {
    status: 'Done',
    chipProps: {
      status: 'Done',
      color: chipColours.chipGreyText,
      backgroundColor: chipColours.chipGreyBg,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Failed: {
    status: 'Failed',
    chipProps: {
      status: 'Failed',
      color: chipColours.chipRedText,
      backgroundColor: chipColours.chipRedBg,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Withdrawn: {
    status: 'Withdrawn',
    chipProps: {
      status: 'Withdrawn',
      color: chipColours.chipGreyText,
      backgroundColor: chipColours.chipGreyBg,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Finalised: {
    status: 'Finalised',
    chipProps: {
      status: 'Finalised',
      color: chipColours.chipGreenText,
      backgroundColor: chipColours.chipGreenBg,
    },
  },
  'Ready to Send': {
    status: 'Ready to Send',
    chipProps: {
      status: 'Ready to Send',
      color: chipColours.chipOrangeText,
      backgroundColor: chipColours.chipOrangeBg,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Sent: {
    status: 'Sent',
    chipProps: {
      status: 'Sent',
      color: chipColours.chipPurpleText,
      backgroundColor: chipColours.chipPurpleBg,
    },
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Sending: {
    status: 'Sending',
    chipProps: {
      status: 'Sending',
      color: chipColours.chipRedText,
      backgroundColor: chipColours.chipRedBg,
    },
  },
  ...pseudoStatusesMap,
};

export const statusFilterOptions = [
  ...caseStatuses,
  'N/A',
] as const;

export const taskDashboardStatusOptions = [
  {
    name: 'Sequencing',
    value: 'Sequencing',
    allowedStages: curationAndCaseStages as readonly TaskDashboardStage[],
  },
  {
    name: 'In Pipeline',
    value: 'In Pipeline',
    allowedStages: curationAndCaseStages as readonly TaskDashboardStage[],
  },
  {
    name: 'Ready to Start',
    value: 'Ready to Start',
    allowedStages: taskDashboardStages as readonly TaskDashboardStage[],
  },
  {
    name: 'In Progress',
    value: 'In Progress',
    allowedStages: taskDashboardStages as readonly TaskDashboardStage[],
  },
  {
    name: 'Done',
    value: 'Done',
    allowedStages: taskDashboardStages as readonly TaskDashboardStage[],
  },
  {
    name: 'On Hold',
    value: 'On Hold',
    allowedStages: taskDashboardStages as readonly TaskDashboardStage[],
  },
] as const;
